/**
 * Feature flag globale per abilitare/disabilitare la logica multitenancy
 *
 * Quando false: Sistema opera sempre in modalità "Europa" (Servers.europe)
 * Quando true: Ripristina comportamento multitenancy originale con selezione tenant dinamica
 */
export var MULTITENANT_ENABLED = true;
/**
 * Feature flag globale per il "tipo di alimentazione" (dietType).
 *
 * Quando false: la voce dietType è riservata agli utenti B2B
 * (onboarding del leader, creazione membro e modifica da profilo).
 * Quando true: la voce dietType è disponibile per TUTTI gli utenti, anche non-B2B.
 *
 * N.B. Il check non va usato direttamente: passa sempre dall'hook `useIsDietTypeEnabled`,
 * che combina questo flag con lo stato B2B dell'utente.
 */
export var DIET_TYPE_ENABLED_FOR_ALL = false;
